var React = require('react');

function MemoX (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffffff","d":"m415.88 222.82.05.17.43 1.94.37 1.96.28 2 .21 2.01.12 2.04.04 2.06-.04 2.06-.12 2.04-.21 2.01-.28 2-.37 1.96-.43 1.94-.05.17 52.69 52.69-36.32 36.32-52.69-52.69-.17.05-1.94.43-1.96.37-1.99.28-2.02.2-2.04.13-2.06.04-2.06-.04-2.04-.13-2.01-.2-1.99-.28-1.97-.37-1.94-.43-.16-.05-52.69 52.69-36.33-36.32 52.69-52.69-.04-.17-.44-1.94-.36-1.96-.29-2-.2-2.01-.13-2.04-.04-2.06.04-2.06.13-2.04.2-2.01.29-2 .36-1.96.44-1.94.04-.17-52.69-52.69 36.33-36.32 52.68 52.69.17-.05 1.94-.43 1.97-.37 1.99-.28 2.01-.2 2.04-.13 2.06-.04 2.06.04 2.04.13 2.02.2 1.99.28 1.96.37 1.94.43.17.05 52.69-52.69 36.32 36.32z"}));
}

MemoX.defaultProps = {"height":"200","preserveAspectRatio":"xMidYMid meet","viewBox":"265.19047619 132.80952381 206.38095238 206.38095238","width":"200"};

module.exports = MemoX;

MemoX.default = MemoX;
